export const showHtmlLoader = () => {
  const loaderElement = document.getElementById('app-loader');
  if (loaderElement) {
    loaderElement.style.display = 'flex';
  }
};

export const setHtmlLoaderText = (text: string) => {
  const textElement = document.getElementById('app-loader-text');
  if (textElement) {
    textElement.textContent = text;
  }
};

export const hideHtmlLoader = () => {
  const loaderElement = document.getElementById('app-loader');
  if (loaderElement) {
    loaderElement.style.display = 'none';
  }
};
